import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import UpdateCorporationDetailSchema from '@/schema/UpdateCorporationDetailSchema';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import { yupResolver } from '@hookform/resolvers';
import { Button, TextField } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import FormInput from '../common/form/input';
import PhoneInput from 'react-phone-input-2';
import './rootOrganization.css';
import {
    onCancelDialog,
    onChangeCorporationOwner,
    getUrlLinkCorporationDetails,
    isDisableBtnSubmitEditBasicInfo,
    getOrgStatus,
    onSubmitEditOrgBasicInfo
} from './EditOrganizationHandler';
import { Autocomplete } from '@material-ui/lab';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useSnackbar } from 'notistack';
import ErrorHelper from '@/component/common/ErrorHelper';
import { userAtom } from '@/state/atom/userAtom';
import GroupActionBlockAndDeleteCorporation from './GroupActionBlockAndDeleteCorporation';

export default function ViewBasicInfo(props) {
    const { enqueueSnackbar } = useSnackbar();
    const userDetail = useRecoilValue(userAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const [organizationDetail, setOrganizationDetail] = useState({});
    const [selectedPersonInCharge, setSelectedPersonInCharge] = useState(props?.ownerData || {});
    const [corporationPhone, setCorporationPhone] = useState(props?.organizationDetail?.tel || '');
    const [isShowDialogCancel, setIsShowDialogCancel] = useState(false);
    const [isShowDialogSubmit, setIsShowDialogSubmit] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    
    const methods = useForm({
        mode: 'all',
        resolver: yupResolver(UpdateCorporationDetailSchema)
    });

    const {
        handleSubmit,
        errors,
        formState,
        getValues,
        setValue,
        reset,
        setError,
        register,
        clearErrors
    } = methods;
    const { isDirty } = formState;

    useEffect(() => {
        register('telNumberCorporation');

        if (!Utils.isEmptyObject(props?.contractDetail)) {
            if (!Utils.isEmptyObject(props?.contractDetail?.corporationData)) {
                let currentCorpData = props?.contractDetail?.corporationData;
                setOrganizationDetail(currentCorpData);
                setCorporationPhone(currentCorpData.tel || '');
                setValue('corporationName', currentCorpData.name);
                setValue('telNumberCorporation', currentCorpData.tel);
            }
            if (!Utils.isEmptyObject(props?.contractDetail?.ownerData)) {
                setSelectedPersonInCharge(props?.contractDetail?.ownerData);
            }
        }
    }, [props?.contractDetail]);

    const onChangePhoneNumber = (phoneValue, country) => {
        setCorporationPhone(phoneValue);
        setIsEdited(true);
        if (phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
            if (!Utils.isGuestContractType(organizationDetail)) {
                setError(
                    'telNumberCorporation',
                    { type: 'manual', message: I18n.get('COMMSG014') },
                    { shouldFocus: false }
                );
            }
        } else {
            setValue('telNumberCorporation', phoneValue);
            clearErrors('telNumberCorporation');
        }
    };

    const onBlurPhoneInput = (e, country) => {
        let phoneValue = e.target.value;
        phoneValue = phoneValue.substring(1);

        if (phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
            if (!Utils.isGuestContractType(organizationDetail)) {
                setError(
                    'telNumberCorporation',
                    { type: 'manual', message: I18n.get('COMMSG014') },
                    { shouldFocus: false }
                );
            }
        } else {
            setValue('telNumberCorporation', phoneValue);
            clearErrors('telNumberCorporation');
        }
    };

    const disabledFieldByStatusCorporation = () => {
        if(organizationDetail.active === Constant.CORPORATION_ACTIVE.ACTIVE) {
            return false;
        }
        return true;
    }

    if (Utils.isEmptyObject(props?.contractDetail)) return <></>;

    return (
        <div className="groupUser">
            <div className="head-btn">
                <div
                    className="head-btn-wrap"
                    style={{
                        minHeight: '32px',
                        float: 'right',
                        width: '100%',
                        justifyContent: 'flex-end'
                    }}
                >
                    <div className="btn-cancel">
                        <Button
                            className="btn-light btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={!(isDirty || isEdited)}
                            onClick={() => onCancelDialog(isDirty, isEdited, setIsShowDialogCancel)}
                        >
                            {I18n.get('COMBTN001')}
                        </Button>
                    </div>
                    <div className="btn-submit">
                        <Button
                            className="btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={
                                !isDisableBtnSubmitEditBasicInfo(
                                    selectedPersonInCharge,
                                    isEdited,
                                    errors
                                )
                            }
                            onClick={() => setIsShowDialogSubmit(true)}
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>

            <GroupActionBlockAndDeleteCorporation
                {...props}
                organizationDetail={organizationDetail}
                setTriggerReload={props.setTriggerReload}
            />

            <div
                className="group-user"
                style={{
                    paddingTop: '16px'
                }}
            >
                <FormProvider {...methods}>
                    {/* org name  */}
                    <div className={'form-addTicket'}>
                        <label className="form-addTicket-label edit-organization-first-input-label">
                            {I18n.get('LABEL-ORG-NAME')}
                            <span className="required">*</span>
                        </label>
                        <div className="form-addTicket-input">
                            <FormInput
                                className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                variant="outlined"
                                name="corporationName"
                                errorlist={errors}
                                autoComplete="off"
                                defaultValue={props?.contractDetail?.corporationData?.name || ''}
                                value={props?.contractDetail?.corporationData?.name || ''}
                                onKeyUp={() => setIsEdited(true)}
                                placeholder={I18n.get('COMMSG067').replace('{{item}}', '組織名')}
                                disabled={disabledFieldByStatusCorporation()}
                            />
                        </div>
                    </div>

                    {/* corporation owner  */}
                    <div className={'form-addTicket'}>
                        <label className="form-addTicket-label edit-organization-input-label">
                            {I18n.get('LABEL-ADMIN-NAME')}
                            <span className="required">*</span>
                        </label>
                        <div className="form-addTicket-input edit-org-pic">
                            <Autocomplete
                                disableClearable
                                id="persion-in-charge-org"
                                getOptionLabel={option => option.fullName || ''}
                                options={props?.contractDetail?.adminList || []}
                                value={selectedPersonInCharge}
                                onChange={(_, value) =>
                                    onChangeCorporationOwner(
                                        value,
                                        setIsEdited,
                                        setSelectedPersonInCharge
                                    )
                                }
                                filterOptions={options =>
                                    options.filter(
                                        option =>
                                            [
                                                Constant.PRIVILEGE_USER.ADMIN,
                                                Constant.PRIVILEGE_USER.ADMIN_OWNER
                                            ].includes(option.privilege) &&
                                            ![
                                                Constant.ACTIVE_FLAG.DELETED,
                                                Constant.ACTIVE_FLAG.INACTIVE
                                            ].includes(option.active)
                                    )
                                }
                                getOptionSelected={(option, selectedValue) =>
                                    option.id === selectedPersonInCharge.id
                                }
                                disabled={disabledFieldByStatusCorporation()}
                                noOptionsText={I18n.get('COMMSG001')}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        className="form-control form-control--wrap form-control--hg32"
                                        error={
                                            Utils.isEmptyObject(selectedPersonInCharge) ||
                                            selectedPersonInCharge?.id === null
                                        }
                                        helperText={
                                            Utils.isEmptyObject(selectedPersonInCharge) ||
                                            selectedPersonInCharge?.id === null
                                                ? I18n.get('COMMSG014')
                                                : ''
                                        }
                                    />
                                )}
                            />
                        </div>
                    </div>

                    {/* mail admin */}
                    <div className={'form-addTicket'}>
                        <label className="form-addTicket-label edit-organization-input-label">
                            {I18n.get('LABEL-ADMIN-MAIL')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="mailAdmin"
                                className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                variant="outlined"
                                autoComplete="off"
                                value={selectedPersonInCharge.mail || ''}
                                disabled={true}
                            />
                        </div>
                    </div>

                    {/* tel number  */}
                    <div className={` ${disabledFieldByStatusCorporation() && 'tel-number-disabled'} form-addTicket`}>
                        <label className="form-addTicket-label edit-organization-input-label">
                            {I18n.get('LABEL-PHONE-NUMBER')}
                            {!Utils.isGuestContractType(organizationDetail) && <span className="required">*</span>}
                        </label>
                        <PhoneInput
                            country={'jp'}
                            disabled={disabledFieldByStatusCorporation()}
                            value={corporationPhone}
                            onChange={onChangePhoneNumber}
                            onBlur={onBlurPhoneInput}
                            countryCodeEditable={false}
                            placeholder={I18n.get('COMMSG067').replace('{{item}}', '電話番号')}
                            inputProps={{
                                name: 'telNumberCorporation',
                                className: 'form-control edit-org-input',
                                variant: 'outlined',
                                size: 'small'
                            }}
                            data-cy="create-org-input-corp-phone"
                        />
                        <div style={{ marginTop: '5px' }}>
                            <ErrorHelper
                                isShowError={
                                    errors && errors.hasOwnProperty('telNumberCorporation')
                                }
                                textError={errors['telNumberCorporation']?.message}
                            />
                        </div>
                    </div>

                    {/* url  */}
                    <div className={'form-addTicket'}>
                        <label className="form-addTicket-label edit-organization-input-label">
                            {I18n.get('LABEL-SUBDOMAIN')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="subDomainCorportion"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                autoComplete="off"
                                disabled={true}
                                value={getUrlLinkCorporationDetails(organizationDetail)}
                            />
                        </div>
                    </div>

                    {/* status  */}
                    <div className={'form-addTicket'}>
                        <label className="form-addTicket-label edit-organization-input-label">
                            {I18n.get('LABEL-STATUS')}
                        </label>
                        <div className="form-addTicket-input">
                            <div
                                className={`user-status user-status-${getOrgStatus(
                                    organizationDetail
                                ).toLowerCase()}`}
                            >
                                {getOrgStatus(organizationDetail)}
                            </div>
                        </div>
                    </div>
                </FormProvider>
            </div>

            {/* dialog cancel  */}
            <ConfirmDialog
                isOpen={isShowDialogCancel}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={handleSubmit(
                    async () =>
                        await onSubmitEditOrgBasicInfo(
                            props?.API,
                            props.orgId,
                            getValues,
                            setIsShowDialogSubmit,
                            props.setIsLoading,
                            enqueueSnackbar,
                            reloadTicketListByPanelType,
                            panelList,
                            setPanelList,
                            props.panelId,
                            props.setTriggerReload,
                            selectedPersonInCharge?.id,
                            userDetail.id,
                            setIsShowDialogCancel,
                            reset,
                            setIsEdited,
                            props.setIsShowReload
                        )
                )}
                closeCallBack={() =>
                    closePanelTab({
                        event: null,
                        panelType: props.panelType,
                        panelId: props.panelId,
                        tabId: props.tabId
                    })
                }
                cancelCallBack={() => {
                    setIsShowDialogCancel(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />

            {/* modal submit  */}
            <ConfirmDialog
                isOpen={isShowDialogSubmit}
                msgConfirm={I18n.get('COMMSG004')}
                okCallBack={handleSubmit(
                    async () =>
                        await onSubmitEditOrgBasicInfo(
                            props?.API,
                            props.orgId,
                            getValues,
                            setIsShowDialogSubmit,
                            props.setIsLoading,
                            enqueueSnackbar,
                            reloadTicketListByPanelType,
                            panelList,
                            setPanelList,
                            props.panelId,
                            props.setTriggerReload,
                            selectedPersonInCharge?.id,
                            userDetail.id,
                            setIsShowDialogCancel,
                            reset,
                            setIsEdited,
                            props.setIsShowReload
                        )
                )}
                closeCallBack={() => setIsShowDialogSubmit(false)}
                textClose={I18n.get('COMBTN007')}
            />
        </div>
    );
}
